function Meteo(log) {
  if (this === window)
    return new Meteo(log);

  this.log = log || [];
  if (this.log.length > 1)
    this._sort();
  this._precompute();
}

const HOURLY_MARGIN = 10; // In minutes. Margin to determine if its an hour.

// Public ///////////////////////////////////////////////////////////

Meteo.prototype.data = function() {
  // Return a table of data
  /* return this.log.map(l => ({...l, datetime: l['datetime'].toISOString()})); */
  return this.log;
}

Meteo.prototype.merge = function(m2) {
  // Merge two Meteo instances into a new one.
  let dates = {};
  for (const line of this.log)
    dates[line.datetime] = true;
  return new Meteo(this.log.concat(m2.filter(l => !dates[l.datetime])));
}

Meteo.prototype.by_month = function() {
  let res   = [];
  let ym    = '';
  let index = 0;
  for (let i = 0; i < this.log.length; i++) {
    let now = this.log[i].date;
    if (now > ym) {
      if (ym)
        res[res.length] = this._slice_index(index, i);
      ym = now.slice(0,7) + '0000'; // 2021-08
      index = i;
    }
  }
  res[res.length] = this._slice_index(index, this.log.length);
  return res;
};

Meteo.prototype.first_date = function() {
  return this.log ? this.log[0].date : null;
};

Meteo.prototype.last_date = function() {
  return this.log ? this.log[this.log.length-1].date : null;
};

Meteo.prototype.hourly = function() {
  let meteo = new Meteo();
  meteo.log = this.log.filter(l => l.datetime.getMinutes() < HOURLY_MARGIN);
  meteo._precomputations();
  return meteo;
};

Meteo.prototype.search = function(params) {
  params;
  // TODO
  /* return new Meteo(this.log.filter(function (line) {
   *   return ((!params.implicateds
   *         || params.implicateds.includes(line.implicated))
   *        && (!params.tags
   *         || line.tags.some(t => params.tags.includes(t))));
   * })); */
  return this;
};

Meteo.prototype.slice = function(start, end) {
  if (start.length == 10) // '2021-09-05'.length
    start = start + 'T00:00:00#';
  if (end.length == 10)
    end = end + 'T23:59:59#';
  
  console.log('slice(', start, ', ', end, ') → ',
              this._search_date(start), '↔',
              this._search_date(end));

  return this._slice_index(
    this._search_date(start),
    this._search_date(end) - 1,
  );
};

// Private //////////////////////////////////////////////////////////

Meteo.prototype._precompute = function() {
  // Do precomputations here
  return this;
};

Meteo.prototype._slice_index = function(start, end) {
  return new Meteo(this.log.slice(start, end + 1));
};

Meteo.prototype._push = function(line) {
  this.log[this.log.length] = line;
};

Meteo.prototype._clone = function() {
  // Efficient self clonning
  let ok = new Meteo();
  ok.log = this.log;
  return ok;
};

Meteo.prototype._search_date = function(date) {
  // date CAN'T BE in this.log
  // Returns where date should be in this.log
  let start = 0;
  let end   = this.log.length - 1;
  return this._search_date_i(date, start, end);
}

Meteo.prototype._search_date_i = function(val, start, end) {
  // val MUST NOT BE in this.log
  // Returns where it should be in this.log

  const mid = ((start + end) / 2) | 0;

  if (val === this.log[mid].date) {
    return mid;
  }

  if (start >= end) {
    return this.log[mid].date < val ? start + 1: start;
  }

  return val < this.log[mid].date
             ? this._search_date_i(val, start, mid - 1)
             : this._search_date_i(val, mid + 1, end);
};

Meteo.prototype._sort = function() {
  this.log.sort((a, b) => a.datetime - b.datetime);
};

// Nodeishes

export default {
  Meteo: Meteo,
}
